import httpClient from "@/http/httpClient";

async function fetchClientData() {
  // return 'https://m-kiruba.github.io/testing/starline.css';
  // return 'https://m-kiruba.github.io/testing/theme2.css';

  const response = await httpClient.get(`init`, {
    baseURL: `${import.meta.env.VITE_VUE_APP_API_URL}/api`,
  });

  // delay 3s
  await new Promise((resolve) => setTimeout(resolve, 3000));

  // return 'http://localhost:3000/theme.css';
  return response.data;
}

function loadCss(url) {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    link.onload = resolve;
    link.onerror = reject;
    document.head.appendChild(link);
  });
}

function applyAccountTitle(accountName) {
  if (accountName) {
    document.title = `Wholesale | ${accountName}`;
  }
}

async function init() {
  try {
    const cachedCssUrl = localStorage.getItem("cssUrl");
    const cachedAccountName = localStorage.getItem("accountName");
    applyAccountTitle(cachedAccountName);

    if (cachedCssUrl) {
      await loadCss(cachedCssUrl);

      fetchClientData().then((data) => {
        localStorage.setItem("cssUrl", data.css_url);
        localStorage.setItem(
          "accountName",
          data.account_details?.account_name ?? ""
        );
        localStorage.setItem(
          "logo_url",
          data.account_details?.logo_url ?? data.logo_url ?? ""
        );
        localStorage.setItem(
          "account_details",
          JSON.stringify(data.account_details)
        );
        applyAccountTitle(data.account_details?.account_name);
        loadCss(data.css_url);
      });
    } else {
      document.getElementById("splash").style.display = "grid";
      document.getElementById("app").style.display = "none";
      const data = await fetchClientData();
      localStorage.setItem("cssUrl", data.css_url);
      localStorage.setItem(
        "accountName",
        data.account_details?.account_name ?? ""
      );
      localStorage.setItem(
        "logo_url",
        data.account_details?.logo_url ?? data.logo_url ?? ""
      );
      localStorage.setItem(
        "account_details",
        JSON.stringify(data.account_details)
      );
      applyAccountTitle(data.account_details?.account_name);
      await loadCss(data.css_url);
    }

    document.getElementById("splash").style.display = "none";
    document.getElementById("app").style.display = "block";

    // Load the actual Vue app
    //   import('./src/main.js');
  } catch (err) {
    console.error("Failed to load theme CSS:", err);
    // sonnet error

    // Fallback UI or retry
  }
}

init();
